import React from 'react'
import { Modal } from '@components/ui'

type MarketingScheduleCampaignModalProps = {
  show: boolean
  launchDateLabel: string
  confirmDisabled?: boolean
  extraDescription?: string
  onCancel: () => void
  onConfirm: () => void
}

const MarketingScheduleCampaignModal: React.FC<
  MarketingScheduleCampaignModalProps
> = ({
  show,
  launchDateLabel,
  confirmDisabled = false,
  extraDescription,
  onCancel,
  onConfirm,
}) => (
  <Modal
    open={show}
    onClose={onCancel}
    size="xs"
    title="Schedule campaign"
    description={[
      `The campaign is set to launch on ${launchDateLabel}.`,
      'Do you want to send it right now and overwrite it?',
      ...(extraDescription ? [extraDescription] : []),
    ]}
    primaryLabel="Confirm"
    secondaryLabel="Cancel"
    primaryDisabled={confirmDisabled}
    onPrimaryClick={onConfirm}
    onSecondaryClick={onCancel}
  />
)

export default MarketingScheduleCampaignModal
